import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { BlowerNodeModel } from './BlowerNodeModel';
import { BlowerNodeWidget } from './BlowerNodeWidget';

export class BlowerNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.Blower);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new BlowerNodeModel();
  }

  nodeUI(event) {
    return (
      <BlowerNodeWidget
        engine={this.engine}
        node={event.model}
        entity={event.model.getEntity()}
        width={243}
        height={144}
        renderedOnMap
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
